import { render, staticRenderFns } from "./ReportFieldTextarea.vue?vue&type=template&id=0c28dc00"
import script from "./ReportFieldTextarea.vue?vue&type=script&lang=js"
export * from "./ReportFieldTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports